"use strict";

var _toConsumableArray = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ordered_object_literal_1 = require("@stoplight/ordered-object-literal");

var types_1 = require("@stoplight/types");

var yaml_ast_parser_1 = require("@stoplight/yaml-ast-parser");

var buildJsonPath_1 = require("./buildJsonPath");

var dereferenceAnchor_1 = require("./dereferenceAnchor");

var lineForPosition_1 = require("./lineForPosition");

var types_2 = require("./types");

var utils_1 = require("./utils");

exports.parseWithPointers = function (value, options) {
  var lineMap = computeLineMap(value);
  var ast = yaml_ast_parser_1.load(value, Object.assign({}, options, {
    ignoreDuplicateKeys: true
  }));
  var parsed = {
    ast: ast,
    lineMap: lineMap,
    data: undefined,
    diagnostics: [],
    metadata: options
  };
  if (!ast) return parsed;
  parsed.data = exports.walkAST(ast, options, lineMap, parsed.diagnostics);

  if (ast.errors) {
    var _parsed$diagnostics;

    (_parsed$diagnostics = parsed.diagnostics).push.apply(_parsed$diagnostics, _toConsumableArray(transformErrors(ast.errors, lineMap)));
  }

  if (parsed.diagnostics.length > 0) {
    parsed.diagnostics.sort(function (itemA, itemB) {
      return itemA.range.start.line - itemB.range.start.line;
    });
  }

  if (Array.isArray(parsed.ast.errors)) {
    parsed.ast.errors.length = 0;
  }

  return parsed;
};

exports.walkAST = function (node, options, lineMap, diagnostics) {
  if (node) {
    switch (node.kind) {
      case types_2.Kind.MAP:
        {
          var preserveKeyOrder = options !== void 0 && options.preserveKeyOrder === true;
          var container = createMapContainer(preserveKeyOrder);
          var seenKeys = [];
          var handleMergeKeys = options !== void 0 && options.mergeKeys === true;
          var yamlMode = options !== void 0 && options.json === false;
          var handleDuplicates = options !== void 0 && options.ignoreDuplicateKeys === false;

          var _iterator = _createForOfIteratorHelper(node.mappings),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var mapping = _step.value;
              if (!validateMappingKey(mapping, lineMap, diagnostics, yamlMode)) continue;
              var key = String(getScalarValue(mapping.key));

              if ((yamlMode || handleDuplicates) && (!handleMergeKeys || key !== "<<")) {
                if (seenKeys.includes(key)) {
                  if (yamlMode) {
                    throw new Error('Duplicate YAML mapping key encountered');
                  }

                  if (handleDuplicates) {
                    diagnostics.push(createYAMLException(mapping.key, lineMap, 'duplicate key'));
                  }
                } else {
                  seenKeys.push(key);
                }
              }

              if (handleMergeKeys && key === "<<") {
                var reduced = reduceMergeKeys(exports.walkAST(mapping.value, options, lineMap, diagnostics), preserveKeyOrder);
                Object.assign(container, reduced);
              } else {
                container[key] = exports.walkAST(mapping.value, options, lineMap, diagnostics);

                if (preserveKeyOrder) {
                  pushKey(container, key);
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return container;
        }

      case types_2.Kind.SEQ:
        return node.items.map(function (item) {
          return exports.walkAST(item, options, lineMap, diagnostics);
        });

      case types_2.Kind.SCALAR:
        {
          var bigInt = options !== void 0 && options.bigInt === true;
          var value = getScalarValue(node);
          return !bigInt && typeof value === 'bigint' ? Number(value) : value;
        }

      case types_2.Kind.ANCHOR_REF:
        {
          if (utils_1.isObject(node.value)) {
            node.value = dereferenceAnchor_1.dereferenceAnchor(node.value, node.referencesAnchor);
          }

          return exports.walkAST(node.value, options, lineMap, diagnostics);
        }

      default:
        return null;
    }
  }

  return node;
};

function getScalarValue(node) {
  switch (yaml_ast_parser_1.determineScalarType(node)) {
    case types_2.ScalarType.null:
      return null;

    case types_2.ScalarType.string:
      return String(node.value);

    case types_2.ScalarType.bool:
      return yaml_ast_parser_1.parseYamlBoolean(node.value);

    case types_2.ScalarType.int:
      return yaml_ast_parser_1.parseYamlBigInteger(node.value);

    case types_2.ScalarType.float:
      return yaml_ast_parser_1.parseYamlFloat(node.value);
  }
}

var computeLineMap = function computeLineMap(input) {
  var lineMap = [];
  var i = 0;

  for (; i < input.length; i++) {
    if (input[i] === '\n') {
      lineMap.push(i + 1);
    }
  }

  lineMap.push(i + 1);
  return lineMap;
};

function getLineLength(lineMap, line) {
  if (line === 0) {
    return Math.max(0, lineMap[0] - 1);
  }

  return Math.max(0, lineMap[line] - lineMap[line - 1] - 1);
}

var transformErrors = function transformErrors(errors, lineMap) {
  var validations = [];
  var possiblyUnexpectedFlow = -1;
  var i = 0;

  var _iterator2 = _createForOfIteratorHelper(errors),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var error = _step2.value;
      var validation = {
        code: error.name,
        message: error.reason,
        severity: error.isWarning ? types_1.DiagnosticSeverity.Warning : types_1.DiagnosticSeverity.Error,
        range: {
          start: {
            line: error.mark.line,
            character: error.mark.column
          },
          end: {
            line: error.mark.line,
            character: error.mark.toLineEnd ? getLineLength(lineMap, error.mark.line) : error.mark.column
          }
        }
      };
      var isBrokenFlow = error.reason === 'missed comma between flow collection entries';

      if (isBrokenFlow) {
        possiblyUnexpectedFlow = possiblyUnexpectedFlow === -1 ? i : possiblyUnexpectedFlow;
      } else if (possiblyUnexpectedFlow !== -1) {
        validations[possiblyUnexpectedFlow].range.end = validation.range.end;
        validations[possiblyUnexpectedFlow].message = 'invalid mixed usage of block and flow styles';
        validations.length = possiblyUnexpectedFlow + 1;
        i = validations.length;
        possiblyUnexpectedFlow = -1;
      }

      validations.push(validation);
      i++;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return validations;
};

var reduceMergeKeys = function reduceMergeKeys(items, preserveKeyOrder) {
  if (Array.isArray(items)) {
    var reduced = items.reduceRight(preserveKeyOrder ? function (merged, item) {
      var keys = Object.keys(item);
      Object.assign(merged, item);

      for (var i = keys.length - 1; i >= 0; i--) {
        unshiftKey(merged, keys[i]);
      }

      return merged;
    } : function (merged, item) {
      return Object.assign(merged, item);
    }, createMapContainer(preserveKeyOrder));
    return reduced;
  }

  return typeof items !== 'object' || items === null ? null : Object(items);
};

function createMapContainer(preserveKeyOrder) {
  return preserveKeyOrder ? ordered_object_literal_1.default({}) : {};
}

function deleteKey(container, key) {
  if (!(key in container)) return;
  var order = ordered_object_literal_1.getOrder(container);
  var index = order.indexOf(key);

  if (index !== -1) {
    order.splice(index, 1);
  }
}

function unshiftKey(container, key) {
  deleteKey(container, key);
  ordered_object_literal_1.getOrder(container).unshift(key);
}

function pushKey(container, key) {
  deleteKey(container, key);
  ordered_object_literal_1.getOrder(container).push(key);
}

function validateMappingKey(mapping, lineMap, diagnostics, yamlMode) {
  if (mapping.key.kind !== types_2.Kind.SCALAR) {
    if (!yamlMode) {
      diagnostics.push(createYAMLIncompatibilityException(mapping.key, lineMap, 'mapping key must be a string scalar', yamlMode));
    }

    return false;
  }

  if (!yamlMode) {
    var type = typeof getScalarValue(mapping.key);

    if (type !== 'string') {
      diagnostics.push(createYAMLIncompatibilityException(mapping.key, lineMap, "mapping key must be a string scalar rather than ".concat(mapping.key.valueObject === null ? 'null' : type), yamlMode));
    }
  }

  return true;
}

function createYAMLIncompatibilityException(node, lineMap, message, yamlMode) {
  var exception = createYAMLException(node, lineMap, message);
  exception.code = 'YAMLIncompatibleValue';
  exception.severity = yamlMode ? types_1.DiagnosticSeverity.Hint : types_1.DiagnosticSeverity.Warning;
  return exception;
}

function createYAMLException(node, lineMap, message) {
  var startLine = lineForPosition_1.lineForPosition(node.startPosition, lineMap);
  var endLine = lineForPosition_1.lineForPosition(node.endPosition, lineMap);
  return {
    code: 'YAMLException',
    message: message,
    severity: types_1.DiagnosticSeverity.Error,
    path: buildJsonPath_1.buildJsonPath(node),
    range: {
      start: {
        line: startLine,
        character: startLine === 0 ? node.startPosition : node.startPosition - lineMap[startLine - 1]
      },
      end: {
        line: endLine,
        character: endLine === 0 ? node.endPosition : node.endPosition - lineMap[endLine - 1]
      }
    }
  };
}